import { createFileRoute } from "@tanstack/react-router";

// Clerk pilote les étapes sous /sign-in (factor-one, factor-two, etc.).
// Le formulaire reste monté dans la route parente pendant ces navigations.
export const Route = createFileRoute("/sign-in/$")({
  component: () => null,
});
